import * as fromInvoice from '../actions/invoice.actions';
import { createSelector } from '@ngrx/store';
import { Pagination } from '../../shared/models/pagination';
import { Invoice } from '../../shared/models/invoice';
import { Prestation } from '../../shared/models/prestation';


export interface InvoiceState {
  invoices: any[];
  openInvoices: any[];
  pagination: Pagination;
  lastNewId : number;
  newPrestation: Prestation;
}

const initState: InvoiceState = {
  invoices: [],
  openInvoices: [],
  pagination: {
    sortField: 'number',
    sortOrder: 2,
    filters: null,
    first: 1,
    rows: 10,
    totalCount: 0,
  },
  lastNewId: -1,
  newPrestation: new Prestation,
};

export function invoiceReducer( state: InvoiceState = initState, action: fromInvoice.invoiceActions): InvoiceState {
    switch ( action.type ) {
     case fromInvoice.ADD_INVOICE: {
       return {
         ...state,
         lastNewId: state.lastNewId - 1,
         openInvoices: [
           ...state.openInvoices,
           Object.assign({id:state.lastNewId - 1, name: '', type: action.typeInvoice, number: 'PROV', date_document: new Date(), date_echeance: new Date()})
         ],
       };
     }
    case fromInvoice.LOAD_INVOICES: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          sortField: action.sortField,
          sortOrder: action.sortOrder,
          filters: action.filters,
          first: action.first,
          rows: action.rows,
        }
      };
    }
    case fromInvoice.LOAD_INVOICES_SUCCESS : {
      return {
        ...state,
        invoices: action.invoices,
        pagination: {
          ...state.pagination,
          totalCount: action.totalCount
        }
      };
    }
    case fromInvoice.OPEN_TAB : {
       if (state.openInvoices.find(c => c.id == action.id)) {
         return {
           ...state
         };
       }
       return {
         ...state,
           openInvoices: [
             ...state.openInvoices,
             {
               id: action.id,
               name: 'Chargement...',
               loading: true,
             }
           ]
       };
    }
     case fromInvoice.CLOSE_TAB:  {
        console.log('close tab', state.openInvoices, action.id);
       return {
         ...state,
         openInvoices: state.openInvoices.filter(c => c.id.toString() !== action.id.toString())
       };
     }

    case fromInvoice.LOAD_INVOICE_SUCCESS : {
       let oc = state.openInvoices.map(c => {
         if (c.id == action.invoice.id) {
           return action.invoice;
         }
         return c;
       });
       return {
         ...state,
           openInvoices: oc
       };
    }

    case fromInvoice.SAVE_INVOICE : {
       const cs = state.openInvoices.map(c =>{
         if (c.id.toString() === action.invoice.id.toString()) {
           return Object.assign(action.invoice, {saved:false});
         }
         return c;
       });
       return {
         ...state,
           openInvoices: cs
       };
    }
    case fromInvoice.SAVE_INVOICE_SUCCESS : {
       const cs = state.openInvoices.map(c =>{
         if (c.id.toString() === action.id.toString()) {
           return Object.assign(action.invoice, {oldId: action.id, saved:true});
         }
         return c;
       });
       return {
         ...state,
           openInvoices: cs
       };
    }
    case fromInvoice.SAVE_INVOICE_ERROR : {
       const cs = state.openInvoices.map(c =>{
         if (c.id.toString() === action.id.toString()) {
           return Object.assign({}, c, {errors:action.error});
         }
         return c;
       });
       return {
         ...state,
           openInvoices: cs
       };
    }
     case fromInvoice.DELETE_INVOICE_SUCCESS:  {
       return {
         ...state,
         openInvoices: state.openInvoices.filter(c => c.id.toString() !== action.id.toString())
       };
     }

    default:
        return state;
    }
}


export const selectInvoice = (state: any) => state.invoice;
export const selectInvoices = createSelector(selectInvoice, (exp) => exp && exp.invoices);
export const selectInvoicePagination = createSelector(selectInvoice, (exp) => exp && exp.pagination);

export const selectInvoiceCount = createSelector(selectInvoice, (exp) => exp && exp.pagination && exp.pagination.totalCount);
export const selectOpenInvoices = createSelector(
  selectInvoice,
  (invoice) => {
    return invoice && invoice.openInvoices;
  }
);

export const selectOpenInvoice = createSelector(
  selectInvoice,
  (invoices, props) => {
    let ar = invoices.invoices.filter(e => e.id.toString() === props.id.toString());
    if (ar.length === 0) return null;
    return ar[0];
  }
);
